import EntityForm from "@/mixins/EntityForm";
import Component, { mixins } from "vue-class-component";

@Component({
  inject: {
    languageService: "languageService",
    eventService: "eventService",
  },
})
export default class OnDemandForm extends mixins(EntityForm) {
  model = {};
  internal_events = [];

  get elements() {
    return [
      {
        id: "code",
        label: this.translations.labels.onDemand_form_code,
        type: "text",
        required: true,
        rules: "min:4",
        onAction: this.noSpaces,
      },
      {
        id: "idEvent",
        label: this.translations.labels.events,
        type: "select",
        items: this.events,
        required: true,
        returnObject: false,
      },
      {
        id: "localizations",
        type: "localizations",
        header: this.translations.labels.form_localizations,
        languages: this.languages,
        resetColumns: true,
        elements: [
          {
            id: "imageUri",
            label: this.translations.labels.event_form_registrationImage,
            type: "media",
            mediaType: "background",
            required: true,
          },
        ],
      },
    ];
  }

  get event () {
    const _event = this.internal_events.filter(
      (e) => {
        return e.id == this.model.idEvent;
      }
    );
    if (_event.length > 0) {
      return _event[0];
    }
    return null;
  }

  get events() {
    return this.internal_events.map((i) => {
      return {
        languages: i.languages,
        label: i.code,
        value: i.id,
      };
    });
  }

  get languages() {
    if (
      this.model.idEvent === undefined ||
      this.model.idEvent === null ||
      this.events === undefined ||
      this.events === null
    )
      return [];
    const event = this.events.filter((e) => e.value == this.model.idEvent)[0];
    if (event != undefined) return event.languages;
    return [];
  }

  get helpLink() {
    return this.translations.pageHelp.onDemand;
  }

  // eslint-disable-next-line no-empty-function
  afterCreate () {
  }

  noSpaces(evt) {
    let charCode = evt.charCode;
    if (charCode === 32) evt.preventDefault();
    return true;
  }

  async created() {
    this.internal_events = await this.eventService.list();
    this.model.event = this.events.filter(
      (e) => e.value == this.model.idEvent
    )[0];

    this.afterCreate();
  }
}
